export const CREATE_TEAMS_MEETING = "CREATE_TEAMS_MEETING";
export const CREATE_TEAMS_MEETING_SUCCESS = "CREATE_TEAMS_MEETING_SUCCESS";

export const UNABLE_TO_BOOK_VIDEO_APPOINTMENT = "UNABLE_TO_BOOK_VIDEO_APPOINTMENT";
export const UNABLE_TO_BOOK_VIDEO_APPOINTMENT_SUCCESS = "UNABLE_TO_BOOK_VIDEO_APPOINTMENT_SUCCESS";

export const COMPLETE_CREATE_VIDEO_CONSULTATION = "COMPLETE_CREATE_VIDEO_CONSULTATION";
export const COMPLETE_CREATE_VIDEO_CONSULTATION_SUCCESS = "COMPLETE_CREATE_VIDEO_CONSULTATION_SUCCESS";
